
export const search = {
  'search.filters.title': 'Filtrer les Subventions',
  'search.filters.geographicEligibility': 'Éligibilité Géographique',
  'search.filters.region': 'Région',
  'search.filters.eligibleCountry': 'Pays Éligible',
  'search.filters.agriculturalSector': 'Secteur Agricole',
  'search.filters.farmingType': 'Type d\'Agriculture',
  'search.filters.farmingType.arableCrops': 'Cultures Arables',
  'search.filters.farmingType.vineyards': 'Vignobles',
  'search.filters.farmingType.livestock': 'Élevage',
  'search.filters.farmingType.aquaculture': 'Aquaculture',
  'search.filters.farmingType.mixedFarming': 'Agriculture Mixte',
  'search.filters.farmingType.greenhouse': 'Serre / Vertical',
  'search.filters.fundingType': 'Type de Financement',
  'search.filters.fundingSource': 'Source de Financement',
  'search.filters.fundingSource.public': 'Public (UE, National)',
  'search.filters.fundingSource.private': 'Privé (Banque, VC)',
  'search.filters.fundingSource.hybrid': 'Hybride (Public-Privé)',
  'search.filters.fundingInstrument': 'Instrument de Financement',
  'search.filters.fundingInstrument.grant': 'Subvention',
  'search.filters.fundingInstrument.subsidy': 'Aide',
  'search.filters.fundingInstrument.taxCredit': 'Crédit d\'Impôt',
  'search.filters.fundingInstrument.loan': 'Prêt',
  'search.filters.fundingInstrument.technicalAssistance': 'Assistance Technique',
  'search.filters.applicationRequirements': 'Exigences de Candidature',
  'search.filters.documentsRequired': 'Documents Requis',
  'search.filters.documentsRequired.businessPlan': 'Plan d\'Affaires',
  'search.filters.documentsRequired.sustainabilityReport': 'Rapport de Durabilité',
  'search.filters.documentsRequired.carbonAssessment': 'Évaluation Carbone',
  'search.filters.documentsRequired.euFarmId': 'ID Ferme UE',
  'search.filters.documentsRequired.digitalCertification': 'Certification Numérique',
  'search.filters.documentsRequired.previousGrantRecord': 'Historique des Subventions',
  'search.filters.applicationFormat': 'Format de Candidature',
  'search.filters.applicationFormat.online': 'En ligne',
  'search.filters.applicationFormat.pdf': 'PDF',
  'search.filters.applicationFormat.portal': 'Via Portail',
  'search.filters.applicationFormat.consultant': 'Avec Consultant Uniquement',
  'search.filters.strategicAlignment': 'Alignement Stratégique',
  'search.filters.sustainabilityGoals': 'Objectifs de Durabilité',
  'search.filters.sustainabilityGoals.organicTransition': 'Transition Biologique',
  'search.filters.sustainabilityGoals.waterEfficiency': 'Efficacité Hydrique',
  'search.filters.sustainabilityGoals.emissionReduction': 'Réduction des Émissions',
  'search.filters.sustainabilityGoals.soilHealth': 'Santé des Sols',
  'search.filters.sustainabilityGoals.biodiversity': 'Biodiversité',
  'search.filters.sustainabilityGoals.climateAdaptation': 'Adaptation Climatique',
  'search.filters.deadlineStatus': 'Statut de l\'Échéance',
  'search.filters.deadline': 'Échéance',
  'search.filters.deadline.open': 'Ouvert',
  'search.filters.deadline.closingSoon': 'Ferme Bientôt (30 jours)',
  'search.filters.deadline.closed': 'Fermé (archive)',
  'search.noResults': 'Aucune subvention trouvée',
  'search.noResultsDesc': 'Aucune subvention ne correspond à vos filtres. Essayez d\'élargir vos critères.',
  'search.filters.noMatches': 'Pas encore d\'ensembles de filtres enregistrés',
  'search.filters.saveFilterSet': 'Enregistrer l\'ensemble de filtres',
  'search.filters.savedFilters': 'Filtres Enregistrés',
  'search.filters.enterFilterSetName': 'Entrez le nom de l\'ensemble de filtres',
  'search.filters.save': 'Enregistrer',
  'search.filters.cancel': 'Annuler',
  
  // Missing search keys
  'search.fundingSearch': 'Recherche de Financement',
  'search.opportunitiesAvailable': 'opportunités disponibles',
  'search.errorLoadingOpportunities': 'Erreur lors du chargement des opportunités',
  'search.errorLoadingDescription': 'Veuillez réessayer plus tard',
  'search.quickFilters': 'Filtres Rapides',
  'search.smartFilters': 'Filtres Intelligents',
  'retry': 'Réessayer',

  // Quick filter buttons
  'search.quickFilters.subsidies': 'Subventions',
  'search.quickFilters.regions': 'Régions Principales',
  'search.quickFilters.agriculture': 'Agriculture',
  'search.quickFilters.urgent': 'Urgentes',

  // UI descriptions
  'search.idealMatch': 'Trouvez le financement idéal',
  'search.popularCombos': 'Combinaisons populaires :',
  'search.smartFiltersTitle': 'Filtres Intelligents & Recherche',
  'search.smartFiltersDescription': 'Filtres Intelligents',

  // French Subsidy Search placeholders
  'search.placeholders.searchByTitleDescriptionAgency': 'Rechercher par titre, description ou agence...',
  'search.placeholders.fundingType': 'Type d\'aide',
  'search.placeholders.sector': 'Secteur',
  'search.placeholders.region': 'Région',
  'search.placeholders.minAmount': 'Montant min (€)',
  'search.placeholders.maxAmount': 'Montant max (€)',
  'search.placeholders.allTypes': 'Tous les types',
  'search.placeholders.allSectors': 'Tous les secteurs',
  'search.placeholders.allRegions': 'Toutes les régions',

  // Smart Filter Panel placeholders
  'search.placeholders.describeProjectOrKeywords': 'Décrivez votre projet ou recherchez par mots-clés...',
  'search.placeholders.selectRegion': 'Sélectionner la région',
  'search.placeholders.selectCategory': 'Sélectionner la catégorie',
  'search.placeholders.selectCountry': 'Sélectionnez d\'abord le pays',
  'search.placeholders.selectDepartment': 'Sélectionner le département',

  // Conversational placeholders
  'search.placeholders.describeProjectOrFunding': 'Décrivez votre projet ou besoin de financement... (Shift+Entrée pour une nouvelle ligne)',

  // Filter panel titles (NEW SIMPLIFIED STRUCTURE)
  'search.searchAndFilterOptions': 'Trouver une Aide Financière',
  'search.fundingOrganizations': 'Organisme de Financement',
  'search.majorFunders': 'Principaux financeurs',
  'search.otherOrganizations': 'Autres organisations',
  'search.filters.moreOrganizations': '+{count} organisations supplémentaires',
  'search.filters.moreRegions': '+{count} régions supplémentaires',
  'search.filters.showLess': 'Voir moins',
  'search.filters.showMore': '+{count} filtres',
  'search.filters.loadingOrganizations': 'Chargement des organisations...',
  'search.filters.active': 'actifs',
  'search.filters.clearAll': 'Tout effacer',

  // New filter sections (SIMPLIFIED STRUCTURE)
  'search.bySituation': 'Par Votre Situation',
  'search.byFundingType': 'Par Type d\'Aide',
  'search.byProjectTheme': 'Par Thème de Projet',
  'search.byDeadline': 'Par Délai & Éligibilité',
  'search.companySize': 'Taille de l\'Entreprise',
  'search.companySize.tpe': 'TPE (0-9 salariés)',
  'search.companySize.pme': 'PME (10-249 salariés)',
  'search.companySize.eti': 'ETI (250-4999 salariés)',
  'search.companySize.ge': 'Grande Entreprise (5000+ salariés)',
  'search.amountLabel': 'Montant',
  'search.projectState': 'État de l\'Appel à Projets',
  'search.projectState.open': 'Ouverts en ce moment',
  'search.projectState.closingSoon': 'Bientôt fermés (moins de 30 jours)',
  'search.projectState.openingSoon': 'Bientôt ouverts',
  'search.projectState.closed': 'Fermés (pour référence)',
  'search.specialCriteria': 'Critères Spéciaux',
  'search.specialCriteria.online': 'Démarches 100% en ligne',
  'search.specialCriteria.newCompany': 'Pour les créateurs d\'entreprise',

  // Project themes (NEW)
  'search.themes.ecological': 'Transition Écologique',
  'search.themes.renewableEnergy': 'Énergies renouvelables',
  'search.themes.circularEconomy': 'Économie circulaire',
  'search.themes.energyRenovation': 'Rénovation énergétique',
  'search.themes.wasteReduction': 'Réduction des déchets',
  'search.themes.innovation': 'Innovation & Numérique',
  'search.themes.rd': 'R&D',
  'search.themes.digitalization': 'Digitalisation',
  'search.themes.cybersecurity': 'Cybersécurité',
  'search.themes.international': 'International',
  'search.themes.export': 'Export',
  'search.themes.foreignExpansion': 'Implantation à l\'étranger',
} as const;
